var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "210 0 540 540",
    strokeWidth: 40,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.543 270v0c0-131.696 106.761-238.457 238.457-238.457v0C622.749 33.453 716.602 146.987 718.457 270v0c0 131.696-106.761 238.457-238.457 238.457v0c-131.696 0-238.457-106.761-238.457-238.457Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M479.441 199.27c86.033-.534 36.495 134.969.559 134.308-33.183-.61-91.348-133.745-.559-134.308ZM401.25 172.706l-22.5-28.671M480 147.74v-30.538M462.427 359.616l36.96-.652M463.511 403.137l33.207-.651M558.75 167.66l22.5-22"
  })));
};
export default SvgLightbulb;